var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRunAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "15 15 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Run-AI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    className: "svg-stroke svg-stroke-color",
    strokeWidth: 1.3,
    x: 15.65,
    y: 15.65,
    width: 18.7,
    height: 18.7
  }), /*#__PURE__*/React.createElement("text", {
    id: "AI",
    className: "svg-path2",
    fontFamily: "SegoeUI-Semibold, Segoe UI",
    fontSize: 14,
    fontWeight: 500,
    letterSpacing: 0.245
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 18.0147656,
    y: 30
  }, "AI")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunAi);
export default __webpack_public_path__ + "static/media/run-AI.856aa4c10b5d65811f67c105af2df413.svg";
export { ForwardRef as ReactComponent };